import {useEffect} from 'react'
import {API, useFind} from '../../../../index'

export const useFetchShow = (kind, id, opts = {}, {watch} = {}) => {
	useEffect(() => {
		API.show(kind, id, opts)
	}, watch ?? [])
	const item = useFind(kind, id)
	return item
}
